import { Button, Dialog, DialogActions, DialogContent, DialogContentText } from '@material-ui/core';
import { ClassAttributes, createElement, MouseEventHandler } from 'react';
import { FormattedMessage } from 'react-intl';

type Props = ClassAttributes<HTMLElement> & {
  onClickAcceptButton: MouseEventHandler<HTMLElement>;
  onRequestClose: MouseEventHandler<HTMLElement>;
  open?: boolean;
  className?: string;
};

const RemoveNotificationDialog = ({ onClickAcceptButton, onRequestClose, open, className }: Props) => {
  return (
    <Dialog open={!!open} onClose={onRequestClose} className={className}>
      <DialogContent>
        <DialogContentText>
          <FormattedMessage id="message.project_update_delete_brief" />
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClickAcceptButton} variant="contained" color="primary">
          <FormattedMessage id="project_editing_page.creative_submitted.remove_dialog.button.ok_label" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RemoveNotificationDialog;
